import React from 'react';
import { Box, Modal, Text } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';
import { intl } from '@fullstory/intl';

export const ConfirmSaveModal: React.FC<{
  onConfirm: () => void;
  onCloseSignal: () => void;
  open: boolean;
}> = ({ onConfirm, onCloseSignal, open }) => (
  <Modal
    data-component="ConfirmSaveModalElemenDataStudio"
    onCloseSignal={onCloseSignal}
    open={open}
    size="small"
    testId="confirm-save-element-modal"
    onClosed={onCloseSignal}
    disableBackdropClick={false}
  >
    <Modal.Header onCloseSignal={onCloseSignal}>
      <Text appearance="bodyLargeBold" color="emphasized">
        <FormattedMessage defaultMessage="Element without event traffic" id="fCkgku" />
      </Text>
    </Modal.Header>
    <Modal.Body>
      <Box
        padding={4}
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        gap={12}
      >
        <Text appearance="bodyMedium">
          <FormattedMessage
            defaultMessage="The element selector(s) you've chosen have not been interacted with in the last 7 days. This may result in tracking an element with no activity. If this is not your intention, choose a different selector."
            id="sihfjZ"
          />
        </Text>
      </Box>
    </Modal.Body>
    <Modal.FooterActions
      primaryAction={{
        action: () => {
          onConfirm();
          onCloseSignal();
        },
        text: intl.formatMessage({
          defaultMessage: 'Save anyway',
          id: 'ZTFoCu',
        }),
        variant: 'fill-primary',
      }}
      secondaryAction={{
        action: onCloseSignal,
        text: intl.formatMessage({
          defaultMessage: 'Choose another selector',
          id: 'ysCtFt',
        }),
      }}
    />
  </Modal>
);
